import React, {useEffect, useState} from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepLabel";
import StepIcon from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepIcon";
import StepButton from "@material-ui/core/StepButton";
import StepConnector from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/StepConnector";
import LoadingView from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/LoadingView";
import RoadUseMainCardTables from "./../../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/RoadUseMainCardTables";
import { State } from "../../../../reducers/reducer";
import { useSelector } from "react-redux";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import {hasRoadData, getStepStatusRoaduse} from "../../../../api/sustainability/allocation/roadUse/data";
import startAllocation from "../../../../api/sustainability/allocationSteps/startAllocation";
import allocationRequirements from "../../../../api/sustainability/allocationSteps/allocationRequirements";
import { useAllocationContainerStyles } from "../../../../common/styles/allocationStyles";

interface Biotemplate {
    id: number;
    biofuel_type: string;
    raw_material_origin: string;
    fuel_type: string;
    raw_material: string;
    double_counted_norway: string;
    reduction_in_climate_emission: number;
    storage_terminal: string;
    available_quantity: number;
    allocated_quantity: number;
    allocated_eq_quantity: number;
}

interface RequirementPercentage {
    general: number;
    advanced: number;
}

interface StepData {
    name: string;
    isDirty: boolean;
    status: string | null;
    isComplete: boolean;
    isDisabled: boolean;
    data: any[];
    allocated: any;
}

interface Steps {
    [key: number]: StepData;
}

const RoadUseContainer: React.FC = () => {
  const classes = useAllocationContainerStyles();

  const isSimulation: any = useSelector((state: State) => state.sustainability.main.isSimulation);
  const isJoint: any = useSelector((state: State) => state.sustainability.main.isJoint);
  const periodName: any = useSelector((state: State) => state.sustainability.main.activePeriod);
  const [availableVol, setAvailableVol] = useState({});
  const [stepSurplusBiotemplates, setStepSurplusBiotemplates] = useState<any[]>([]);
  const [stepTwoBiotemplates, setStepTwoBiotemplates] = useState<Biotemplate[]>([]);
  const [stepThreeBiotemplates, setStepThreeBiotemplates] = useState<Biotemplate[]>([]);
  const [stepFourBiotemplates, setStepFourBiotemplates] = useState<Biotemplate[]>([]);
  const [stepFiveBiotemplates, setStepFiveBiotemplates] = useState<Biotemplate[]>([]);
  const [stepJointFulfBiotemplates, setStepJointFulfBiotemplates] = useState<Biotemplate[]>([]);
  const [isJointActive, setIsJointActive] = useState(false);
  const [isOutJointActive, setIsOutJointActive] = useState(false);
  const [isAboveMandateAfterFulfillActive, setIsAboveMandateAfterFulfillActive] = useState(false);
  const [isSurplusActive, setIsSurplusActive] = useState(false);
  const [isReqByCustomerActive, setIsReqByCustomerActive] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [requirementPercentages, setRequirementPercentages] = useState<RequirementPercentage>({
    general: 0,
    advanced: 0,
  });
  const [steps, setSteps] = useState<Steps>({
        1: {
            name: "Volume flexibility IN from off-road",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        2: {
            name: "Advanced Sub-Mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        3: {
            name: "General Mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        4: {
            name: "Reserved above the mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        5: {
              name: "Joint Fulfillment OUT",
              isDirty: false,
              status: "",
              isComplete: false,
              isDisabled: true,
              data: [],
              allocated: {},
        },
        6: {
            name: "Additional volumes above the mandate",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        7: {
            name: "Matching",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        8: {
            name: "Customer Requirements",
            isDirty: false,
            status: "",
            isComplete: false,
            isDisabled: false,
            data: [],
            allocated: {},
        },
        9: {
            name: "Report overview",
            isDirty: false,
            isDisabled: false,
            status: "",
            isComplete: false,
            data: [],
            allocated: {},
        },
    });

  const fetchBiotemplateData = async () => {
        const response = await startAllocation("roaduse");
        if (response && response.valid) {
            const reqResponse = await allocationRequirements({});
            if (reqResponse && reqResponse.valid) {
                // @ts-ignore
                setStepTwoBiotemplates(reqResponse.adv_biofuels_req.biotemplates);
                // @ts-ignore
                setStepThreeBiotemplates(reqResponse.general_req.biotemplates);
                // @ts-ignore
                setStepFourBiotemplates(reqResponse.above_req.biotemplates);
                // @ts-ignore
                setStepJointFulfBiotemplates(reqResponse.joint_req.biotemplates || []);
                // @ts-ignore
                setStepFiveBiotemplates(reqResponse.additional_req.biotemplates || []);
            } else if (response.biotemplates) {
                const advancedBiotemplates = response.biotemplates.filter((template: Biotemplate) => template.double_counted_norway === "Ja");
                // @ts-ignore
                setStepTwoBiotemplates(advancedBiotemplates);
                // @ts-ignore
                setStepThreeBiotemplates(response.biotemplates);
                // @ts-ignore
                setStepFourBiotemplates(response.biotemplates);
                // @ts-ignore
                setStepJointFulfBiotemplates(response.biotemplates || []);
                // @ts-ignore
                setStepFiveBiotemplates(response.biotemplates || []);
            }
            const surplus = response.surplus_biotemplates;
            setStepSurplusBiotemplates(
              Array.isArray(surplus) ? surplus : surplus != null && typeof surplus === "object" ? Object.values(surplus) : []
            );
            const availableData = {};
            // @ts-ignore
            if (response.biotemplates) {
                response.biotemplates.forEach((item: Biotemplate) => {
                    // @ts-ignore
                    availableData[item.biotemplate_id] = item.available_quantity;
                });
            }

            // @ts-ignore
            setAvailableVol(availableData);
        } else {
            alert("Some error occured");
        }
    };

  const updateIsFetching = (value: boolean) => {
        setIsFetching(value);
    };

  const isStepDisabled = (stepNumber: number, stepStatusData?: any) => {
        switch (stepNumber) {
            case 1:
                return !isSurplusActive;
            case 4:
                return !isReqByCustomerActive;
            case 5:
                return !isOutJointActive;
            case 6:
                if (stepStatusData) {
                    const step3Status = stepStatusData[2]; // step 3 (index 2)
                    return !(step3Status === 2 || step3Status === 3);
                }
                return !isAboveMandateAfterFulfillActive;
            default:
                return false;
        }
    };

  const getStepStatus = async (currentStep?: number) => {
        try {
            const data = await getStepStatusRoaduse();
            if (data) {
                setSteps((prevSteps: Steps) => {
                    const updatedSteps: Steps = { ...prevSteps };

                    data.step_status.forEach((statusValue: number, index: number) => {
                        const stepKey = index + 1;

                        if (statusValue === 1 && stepKey === 3) {
                            setIsAboveMandateAfterFulfillActive(false);
                        } else if ((statusValue === 2 || statusValue === 3) && stepKey === 3) {
                            setIsAboveMandateAfterFulfillActive(true);
                        }

                        let status = null;
                        if (statusValue === 1) {
                            status = "Not Complete";
                        } else if (statusValue === 2) {
                            status = "Complete";
                        } else if (statusValue === 3) {
                            status = "Overallocated";
                        }

                        if (updatedSteps[stepKey]) {
                            updatedSteps[stepKey] = {
                                ...updatedSteps[stepKey],
                                status,
                            };
                        }
                    });

                    return updatedSteps;
                });

                // If currentStep is provided, calculate next active step
                if (currentStep !== undefined) {
                    let nextStep = currentStep + 1;
                    while (nextStep <= 9) {
                        if (isStepDisabled(nextStep, data.step_status)) {
                            nextStep++;
                        } else {
                            break;
                        }
                    }
                    return nextStep <= 9 ? nextStep : null;
                }
            }
            return data;
        } catch (error) {
            // tslint:disable-next-line:no-console
            console.error("Error fetching step status:", error);
            return null;
        }
    };

  const checkData = async () => {
        const roadUse = await hasRoadData();
        const isSurplusActiveVal = roadUse ? roadUse.use_offroad_surplus : false;

        let initialStep = 1;
        if (roadUse && parseInt(roadUse.last_active_step) > 0) {
          initialStep = parseInt(roadUse.last_active_step);
        } else if (!isSurplusActiveVal) {
            initialStep = 2;
        }
        setActiveStep(initialStep);
        setIsJointActive(roadUse ? roadUse.joint_fulfillment : false);
        setIsOutJointActive(roadUse ? roadUse.out_joint_fulfillment : false);
        setIsAboveMandateAfterFulfillActive(roadUse ? roadUse.above_mandate_after_fulfill_step_active : false);
        setIsSurplusActive(isSurplusActiveVal);
        setIsReqByCustomerActive(roadUse ? roadUse.req_by_customer : false);
        setRequirementPercentages({
          general: roadUse ? roadUse.general_mandate : 0,
          advanced: roadUse ? roadUse.advanced_sub_mandate : 0,
        });
        if (roadUse) {
            getStepStatus();
        }
    };

  useEffect(() => {
      setIsFetching(true);
      checkData();
      fetchBiotemplateData();
      setIsFetching(false);
  }, []);

  useEffect(() => {
        setSteps((prevSteps: Steps) => ({
            ...prevSteps,
            1: {
                ...prevSteps[1],
                isDisabled: !isSurplusActive,
            },
        }));
    }, [isSurplusActive]);
  useEffect(() => {
        setSteps((prevSteps: Steps) => ({
            ...prevSteps,
            4: {
                ...prevSteps[4],
                isDisabled: !isReqByCustomerActive,
            },
        }));
    }, [isReqByCustomerActive]);
  useEffect(() => {
        setSteps((prevSteps: Steps) => ({
            ...prevSteps,
            5: {
                ...prevSteps[5],
                isDisabled: !isOutJointActive,
            },
        }));
        if (!isOutJointActive) {
            setStepJointFulfBiotemplates([]);
        }
    }, [isOutJointActive]);
  useEffect(() => {
        setSteps((prevSteps: Steps) => ({
            ...prevSteps,
            6: {
                ...prevSteps[6],
                isDisabled: !isAboveMandateAfterFulfillActive,
            },
        }));
    }, [isAboveMandateAfterFulfillActive]);

  return (
    <>
        <div className={clsx(classes.root)}>
            <div className={classes.textContainer}>
                <Typography variant="h6">
                    Allocation Mode:
                    <span className={classes.textPrimary}>{isSimulation ? "Simulation" : "Reporting"}</span>
                </Typography>
            </div>
            <div className={classes.textContainer}>
                <Typography variant="h6">
                    Mandate:
                    <span className={classes.textPrimary}>Road use</span>
                </Typography>
            </div>
            <div className={classes.textContainer}>
                <Typography variant="h6">
                    Period:
                    <span className={classes.textPrimary}>{periodName ? periodName.year : ""}</span>
                </Typography>
            </div>
            <div className={classes.textContainer}>
                <Typography variant="h6">
                    Fulfillment Type:
                    <span className={classes.textPrimary}>{isJointActive ? "Joint" : "Own"}</span>
                </Typography>
            </div>
        </div>
        <Stepper
            alternativeLabel
            nonLinear
            activeStep={activeStep - 1}
            connector={<StepConnector />}
            className={classes.stepper}
        >
            {Object.keys(steps).map((rank, index) => {
                const stepNumber = parseInt(rank);
                return (
                    <Step key={index}>
                        <StepButton
                            onClick={() => console.log(activeStep)}
                            disabled={steps[stepNumber].isDisabled}
                        >
                            <StepLabel
                                StepIconComponent={props => (
                                    <StepIcon
                                        disabled={steps[stepNumber].isDisabled}
                                        status={steps[stepNumber].isDisabled ? null : steps[stepNumber].status}
                                        {...props}
                                    ></StepIcon>
                                )}
                            >
                                {steps[stepNumber].name}
                            </StepLabel>
                        </StepButton>
                    </Step>
                );
            })}
        </Stepper>
        {isFetching ? (
            <LoadingView text={"Data is getting prepared"} />
        ) : (
            <>
                <RoadUseMainCardTables
                    step={activeStep}
                    reqByCustomerDisabled={!isReqByCustomerActive}
                    outJointDisabled={!isOutJointActive}
                    aboveMandateAfterFulfillDisabled={!isAboveMandateAfterFulfillActive}
                    surplusStepDisabled={!isSurplusActive}
                    handleNext={async () => {
                        setIsFetching(true);
                        if (activeStep && activeStep > 0 && activeStep < 9) {
                            const nextStep = await getStepStatus(activeStep);
                            if (nextStep) {
                                setActiveStep(nextStep);
                                fetchBiotemplateData();
                            }
                        }
                        setIsFetching(false);
                    }}
                    handleBack={async () => {
                        if (activeStep > 1) {
                            setIsFetching(true);
                            setActiveStep(activeStep - 1);
                            await fetchBiotemplateData();
                            setIsFetching(false);
                        }
                    }}
                    updateIsFetching={updateIsFetching}
                    availableVol={availableVol}
                    stepTwoData={stepTwoBiotemplates}
                    stepThreeData={stepThreeBiotemplates}
                    stepFourData={stepFourBiotemplates}
                    stepJointFulfData={stepJointFulfBiotemplates}
                    stepFiveData={stepFiveBiotemplates}
                    surplusBiotemplates={stepSurplusBiotemplates}
                    requirementPercentages={requirementPercentages}
                />
            </>
        )}
    </>
  );
};

export default RoadUseContainer;
